import React, { createContext, useContext, useState } from 'react';
import { Lang, Mode, BiText } from '../types';

interface AppContextValue {
  lang: Lang;
  mode: Mode;
  setLang: (l: Lang) => void;
  setMode: (m: Mode) => void;
  t: (text: BiText) => string;
}

const AppContext = createContext<AppContextValue>(null!);

export const AppProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [lang, setLang] = useState<Lang>('es');
  const [mode, setMode] = useState<Mode>('ejecutivo');

  const t = (text: BiText): string => text[lang];

  return (
    <AppContext.Provider value={{ lang, mode, setLang, setMode, t }}>
      {children}
    </AppContext.Provider>
  );
};

export const useApp = () => useContext(AppContext);
